import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { AbstractComponent } from '@seb/web-common/core/components/cms/abstract-component.component';
import { IadvizeStarterInterface } from '@seb/web-common/core/models/cms/iadvize-starter.interface';
import { take } from 'rxjs';

@Component({
  selector: 'wc-iadvize-starter',
  templateUrl: './iadvize-starter.component.html',
  styleUrls: ['./iadvize-starter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class IadvizeStarterComponent extends AbstractComponent<IadvizeStarterInterface> implements OnInit {
  iAdvizeId = signal<string>(undefined);

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$
        .pipe(take(1))
        .subscribe((cmp: IadvizeStarterInterface) => {
          this.iAdvizeId.set(cmp.elementId);
        })
    );
  }
}
